import ResourceToken from '@apps/maha/admin/tokens/resource'
import ResourceCard from '@apps/maha/admin/cards/resource'
import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'
import React from 'react'
import Edit from './edit'
import New from './new'

const mapPropsToPanel = (props, context) => ({
  title: 't(Resources)',
  collection: {
    endpoint: '/api/admin/truevail/admin/resources',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true, format: (resource) => (
        <ResourceToken resource={ resource } />
      ) },
      { label: 't(Status)', key: 'status', collapsing: true, format: StatusToken  }
    ],
    empty: {
      title: 't(No Resources)',
      text: 't(There are no resources)',
      svg: 'library',
      buttons: [
        { label: 't(Create Resource)', modal: New }
      ]
    },
    card: (resource) => (
      <ResourceCard resource={ resource } />
    ),
    entity: 'team',
    defaultSort: { key: 'created_at', order: 'desc' },
    recordTasks: (record) => [
      {
        label: 't(Edit Resource)',
        svg: 'square_pen',
        modal: <Edit resource={ record } />
      },
      {
        label: 't(Publish Resource)',
        svg: 'check',
        show: record.status === 'draft',
        request: {
          endpoint: `/api/admin/truevail/admin/resources/${record.id}/publish`,
          method: 'PATCH',
          body: { status: 'published' },
          onSuccess: () => context.flash.set('success', 't(Successfully published this resource)'),
          onFailure: () => context.flash.set('error', 't(Unable to published this resource)')
        }
      },
      {
        label: 't(Unpublish Resource)',
        svg: 'ban',
        show: record.status === 'published',
        request: {
          endpoint: `/api/admin/truevail/admin/resources/${record.id}/publish`,
          method: 'PATCH',
          body: { status: 'draft' },
          onSuccess: () => context.flash.set('success', 't(Successfully unpublished this resource)'),
          onFailure: () => context.flash.set('error', 't(Unable to unpublished this resource)')
        }
      },
      {
        label: 't(Delete Resource)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this resource?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/admin/resources/${record.id}`,
          method: 'DELETE',
          onSuccess: () => context.flash.set('success', 't(Successfully deleted resource)'),
          onFailure: () => context.flash.set('error', 't(Unable to delete resource)')
        }
      }
    ],
    onClick: (record) => {
      if(record.type === 'document') {
        window.location.href = record.remix_url || `/api/admin/assets/${record.asset.fingerprint}/download?token=${context.admin.token}`
      } else {
        context.host.window.open(record.remix_url)
      }
    }
  },
  task: {
    tooltip: 't(Create Resource)',
    modal: New
  }
})

export default Panel(null, mapPropsToPanel)
